import { UserprofileEndpoint } from "@/views/loyalty/shared/endpoint_services/userprofile-endpoint-service"
import { SearchStuffModel } from "@/views/loyalty/models/search_stuff.model"

export class Userprofile {
    constructor (store) {
        this.userProfileEndpoint = new UserprofileEndpoint(store)
    }

    async createUserProfile (customerId, customerNumber, userProfile) {
        return this.userProfileEndpoint.create_user_profile(customerId, customerNumber, userProfile)
    }

    async getCustomerNumbers (userProfileId) {
        return this.userProfileEndpoint.get_customer_numbers(userProfileId)
    }

    async getUserProfileByLogin (login) {
        return this.userProfileEndpoint.get_user_profile_by_login(login)
    }

    async getUserProfileListByCustomerId (customerId, page, limit, filter, search) {
        return this.userProfileEndpoint.get_user_profile_list_by_customer_id(customerId, page, limit, filter, search || SearchStuffModel)
    }

    // Get all records of users for CustomerId
    getUserProfileListByCustomerIdAll (customerId) {
        return this.userProfileEndpoint.get_user_profile_list_by_customer_id(customerId, 1, -1, [], SearchStuffModel)
        // return this.userProfileEndpoint.get_user_profile_list_by_customer_id(customerId, 1, -1, [], { fieldNames: [{ value: 'name', filterType: 'text' }], fieldValue: '' })
    }

    async getUserProfileAll () {
        return this.userProfileEndpoint.get_user_profile_participant_all()
    }

    async updateUserProfile (userProfile) {
        return this.userProfileEndpoint.update_user_profile(userProfile)
    }

    async updateUserProfileCreatePassword (userProfileId, createPassword) {
        await this.userProfileEndpoint.update_user_profile_create_password(userProfileId, createPassword)
    }

    async uploadFile (customerId, customerNumber, file_to_upload) {
        await this.userProfileEndpoint.upload_file(customerId, customerNumber, file_to_upload)
    }
}
